import styled from "styled-components";

const NoGamesImg = styled.img`
  border-radius: 5px;
`;

export default NoGamesImg;
